<template>
    <div>
        <v-dialog
            v-model="dialog"
            class="primary darken-1"
            max-width="1000"
            persistent
        >
            <v-card class="pt-3 pb-6 px-6 primary darken-2">
                <div v-if="exportLoading" class="mb-2" style="display: flex; align-items: center; justify-content: flex-end; width: 100%;">
                    <span class="secondary--text text--lighten-1">Exportando</span>
                    <v-progress-circular
                        class="ml-2"
                        :width="2"
                        size="20"
                        color="secondary lighten-1"
                        indeterminate
                    ></v-progress-circular>
                </div>
                <div id="data-table-to-export" class="primary darken-1 pt-1 px-4">
                    <h3 class=" my-4" v-if="dataPeriodDate" style="color: #A0A0A0;font-weight: normal;font-size: 12px;line-height: 16px;">
                        <v-icon color="#A0A0A0" small>mdi-calendar-month-outline</v-icon>
                        Visualizando dados de {{formatDate(dataPeriodDate[0])}} a {{formatDate(dataPeriodDate[1])}}
                    </h3>
                    <h1 class="subtitle-1 font-weight-bold">
                        {{searchResult.station.nome}}
                    </h1>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        class="primary darken-1 white--text"
                        hide-default-footer
                        :page.sync="page"
                        :items-per-page="itemsPerPage"
                        @page-count="pageCount = $event"
                    >
                        <template v-slot:[`item.date`]="{ item }">
                            <v-timeline class="timeline-table" dense>
                                <v-timeline-item 
                                    color="primary lighten-1"
                                    small
                                    fill-dot
                                    :hide-dot="!item.highlightDate"
                                >
                                    <span v-if="item.highlightDate">{{ item.date }}</span>
                                </v-timeline-item>
                            </v-timeline>
                        </template>
                        <template v-slot:[`item.hour`]="{ item }">
                            <v-timeline class="timeline-table" dense>
                                <v-timeline-item 
                                    color="primary lighten-1"
                                    small
                                    fill-dot
                                    :hide-dot="!item.highlightHour"
                                >
                                    <span v-if="item.highlightHour">{{ item.hour }}</span>
                                </v-timeline-item>
                            </v-timeline>
                        </template>
                        <template v-for="(sensorKey, index) in sensorColumnKeys" v-slot:[`item.sensor${sensorKey}Value`]="{ item }">
                            <observed-sensor-value-export-table
                                :index="index"
                                :item="item"
                                :sensorKey="sensorKey"
                                :key="index"
                                :qualitiesTags="qualitiesTags"
                            >
                            </observed-sensor-value-export-table>
                        </template>
                    </v-data-table>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import moment from "moment";
import ObservedSensorValueExportTable from "./ObservedSensorValueExportTable.vue";
// eslint-disable-next-line no-unused-vars
import { jsPDF } from "jspdf";
// eslint-disable-next-line no-unused-vars
import html2canvas from "html2canvas";
export default {
    name: "ObservedTableDataToPDFExport",
    props: {
        searchResult:{
            type: Object
        },
        dataPeriodDate:{
            type: Array,
        },
        qualitiesTags:{
            type: Array,
        },
        exportFileName: {
            type: String,
        }
    },
    components:{
        ObservedSensorValueExportTable,
    },
    data:()=>({
        showDateWithEmptyData: true,
        itemsPerPage: 10,
        page: 1,
        pageCount: undefined,
        headers: [],
        items:[],
        tablesWidth: "",
        sensorColumnKeys: [],
        dialog: false,
        exportLoading: false,
    }),

    created(){
        this.initialize();
    },

    watch:{
        itemsPerPage(value){
            if(value){
                this.page = 1;
            }
        },

        searchResult(value){
            if(value){
                this.initialize();
            }
        }
    },

    methods:{
        initialize(){
            const { sensors, resultList } = this.searchResult;
            this.sensorColumnKeys = sensors.map((sensor) => sensor.codigo);
            this.headers = this.generateHeaders(sensors);
            const generatedItems = this.generateHourlyItems(resultList);
            const groupItems = this.groupItemsByDate(generatedItems);
            this.items = this.sortGroupItemsByMinute(groupItems);
        },

        generateHeaders(sensors){
            const headers = []
            const dateHeader = {
                text: "Dia",
                align: 'start',
                sortable: false,
                value: 'date',
                width: 80,
            };
            const hourHeader = {
                text: "Hora",
                align: 'center',
                sortable: false,
                value: 'hour',
                width: 100,
            };
            const minuteHeader = {
                text: "Minuto",
                align: 'center',
                sortable: false,
                value: 'minute',
                width: 100,
            };
            headers.push(dateHeader);
            headers.push(hourHeader);
            headers.push(minuteHeader)
            for (const sensor of sensors) {
                const { codigo, name } = sensor;
                headers.push({
                    text: name,
                    align: 'center',
                    sortable: true,
                    value: `sensor${codigo}Value`,
                    width: 200,
                });
            }
            return headers;
        },

        generateHourlyItems(resultList){
            const items = [];
            for (const result of resultList) {
                const { datahora } = result;
                items.push({
                    date: moment(datahora).tz("America/Sao_Paulo").format("DD/MM/YYYY"),
                    hour:moment(datahora).tz("America/Sao_Paulo").format("HH"),
                    minute:moment(datahora).tz("America/Sao_Paulo").format("mm"),
                    dateIso: datahora,
                    value: result.leitura,
                    sensorId: result.sensorId,
                    qualidadeId: result.leitura || result.leitura === 0 ? result.qualidadeId : undefined,
                });
            }
            return items;
        },

        groupItemsByDate(items){
            const groupItems = [];
            const dateKeys = [];
            for (const item of items) {
                const { date, hour, minute } = item;
                if(!dateKeys.find((dateKey) => dateKey.date === date && dateKey.hour === hour && dateKey.minute === minute)) dateKeys.push({date, hour, minute});
            }
            for (const dateKey of dateKeys) {
                const { date, hour, minute } = dateKey;
                let groupItem = { date, hour, minute };
                const resultsByDate = items.filter((item) => item.date === date && item.hour === hour && item.minute === minute);
                for (const result of resultsByDate) {
                    const { value, sensorId, dateIso, qualidadeId } = result; 
                    groupItem.dateIso = moment(dateIso).tz("America/Sao_Paulo").format("YYYY-MM-DDTHH:mm");
                    groupItem[`sensor${sensorId}Value`] = value;
                    groupItem[`sensor${sensorId}Id`] = sensorId;
                    groupItem[`sensor${sensorId}qualityId`] = qualidadeId;
                }
                groupItems.push(groupItem);
            }
            return groupItems;
        },

        sortGroupItemsByMinute(groupItems){
            const hourInterval = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"];
            const minutesInterval = [ "00", "15", "30", "45" ];
            const datesGroup = [];
            for (const item of groupItems) {
                const { date/* , minute */ } = item;
                if(!datesGroup.find((dateGroup) => dateGroup === date /* && dateGroup.minute === minute */)){
                    datesGroup.push(date)
                }
            }
            const sortedGroups = [];
            for (const date of datesGroup) {
                let firstDateAdded = false;
                for (const hour of hourInterval) {
                    let firstHourAdded = false;
                   for (const minute of minutesInterval) {
                        const findGroupItem = groupItems.find(item => item.date === date && item.hour === hour && item.minute === minute);
                        if(findGroupItem){
                                sortedGroups.push({...findGroupItem, highlightDate: !firstDateAdded, highlightHour: !firstHourAdded}); 
                                if(!firstDateAdded) firstDateAdded = true;
                                if(!firstHourAdded) firstHourAdded = true;
                        }
                   }                    
                }
            }
            return sortedGroups;
        },

        generatePDF(settings) {
            const rawItems = Object.assign([], this.items);
            this.items = this.sortGroupItemsByMinute(this.applySettings(settings, this.items));
            this.dialog = true;
            this.exportLoading = true;
            this.itemsPerPage = 200;
            setTimeout( async ()=>{
                const tableElement = document.getElementById('data-table-to-export');
                const canvas = await html2canvas(tableElement);
                var imgData = canvas.toDataURL('image/png');
                var imgWidth = 210; 
                var pageHeight = 295;  
                var imgHeight = canvas.height * imgWidth / canvas.width;
                var heightLeft = imgHeight;
                var doc = new jsPDF('p', 'mm');
                var position = 0;
                doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
                while (heightLeft >= 0) {
                    position = heightLeft - imgHeight;
                    doc.addPage();
                    doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                    heightLeft -= pageHeight;
                }
                await doc.save(`${this.exportFileName}.pdf`, { returnPromise: true });
                this.itemsPerPage = 10;
                this.exportLoading = false;
                this.dialog = false;
                this.items = rawItems;
            }, 1000);
        },

        applySettings(settings, items){
            const {option, replaceData} = settings;
            if(option === "replace-data" && replaceData){
                return this.replaceEmptyValue(items, replaceData);
            }
            if(option === "remove-dates-with-empty-values"){
                return this.removeDatesWithEmptyValues(items);
            }
            return items;
        },

        replaceEmptyValue(items, replaceData){
            const itemsReplaced = [];
            for (const item of items) {
                const verifyItem = Object.assign({}, item);
                const keys = Object.keys(verifyItem);
                for (const key of keys) {
                    if(key === "date" || key === "hour") continue;
                    if(verifyItem[key] !== 0 && !verifyItem[key]){
                        verifyItem[key] = replaceData;
                    }
                }
                itemsReplaced.push(verifyItem);
            }
            return itemsReplaced;
        },

        removeDatesWithEmptyValues(items){
            const itemsReplaced = [];
            for (const item of items) {
                const verifyItem = Object.assign({}, item);
                const verifyItemAsArray = Object.entries(verifyItem);
                const emptyDates = verifyItemAsArray.filter((entryItem) => {
                    const [ key, value ] = entryItem;
                    return key.includes("Value") && (value || value === 0)
                });
                if(emptyDates.length){
                    itemsReplaced.push(verifyItem);
                }
            }
            return itemsReplaced;
        },

        formatDate(date){
            const stringFormat = "DD/MM/YYYY HH:mm";
            return moment(date).tz("America/Sao_Paulo").locale("pt-br").format(stringFormat);
        },
    }
}
</script>

<style scoped>
    
</style>